import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

import * as common from '../../../../../common'

export const DOC = gql`
  ${common.gql.values.fragments.valueWithInfo.DOC}
  fragment FragmentGeneralLedgerRecordAttribute on GeneralLedgerRecordAttribute {
    id
    value {
      ...FragmentValueWithInfo
    }
  }
`

export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentGeneralLedgerRecordAttributeFragment,
  ents.extra.rate.gl.Record.Attribute
>({
  id: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    ents.core.dms.models.Attribute.Id.assertIsId,
    { warnOnly: true },
  ),
  value: graphql.transformers.OUT.pipe(
    common.gql.values.fragments.valueWithInfo.TRANSFORMER,
    graphql.transformers.OUT.select('raw', transformers.PASS_THROUGH),
  ),
})
